import React, { useEffect } from 'react';
import { useSidebarState } from '../../hooks/useSidebarState';
import { SidebarLogo } from './sidebar/SidebarLogo';
import { SidebarToggle } from './sidebar/SidebarToggle';
import { SidebarNav } from './sidebar/SidebarNav';
import { motion } from 'framer-motion';
import { useLanguage } from '../../contexts/LanguageContext';
import { useLocation } from 'react-router-dom';

export const Sidebar = () => {
  const { isCollapsed, isMobileOpen, closeMobile, setCollapsed } = useSidebarState();
  const { direction } = useLanguage();
  const location = useLocation();

  // Close mobile sidebar on route change
  useEffect(() => {
    closeMobile();
  }, [location, closeMobile]);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < 1024;
      if (!isMobile) {
        closeMobile();
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial check

    return () => window.removeEventListener('resize', handleResize);
  }, [closeMobile, setCollapsed]);

  return (
    <>
      {/* Mobile Overlay */}
      {isMobileOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-20 lg:hidden"
          onClick={closeMobile}
        />
      )}

      <motion.aside 
        initial={false}
        animate={{ 
          width: isCollapsed ? 80 : 280
        }}
        transition={{
          type: "spring",
          stiffness: 300,
          damping: 30
        }}
        className={`
    fixed ${direction === 'rtl' ? 'right-0' : 'left-0'} top-0 h-screen 
    bg-white/90 backdrop-blur-md
    border-${direction === 'rtl' ? 'l' : 'r'} shadow-lg
    py-6 z-30 overflow-hidden
    hidden lg:block
    w-20 ${isCollapsed ? '' : 'w-72'}
  `}
      >
        <SidebarToggle />
        <SidebarLogo />
        <SidebarNav />
      </motion.aside>

      {/* Mobile Sidebar */}
      <motion.aside 
        initial={false}
        animate={{ 
          x: isMobileOpen ? 0 : direction === 'rtl' ? 280 : -280
        }}
        transition={{
          type: "spring",
          stiffness: 300,
          damping: 30
        }}
       className={`
    fixed ${direction === 'rtl' ? 'right-0' : 'left-0'} top-0 h-screen 
    bg-white/90 backdrop-blur-md
    border-${direction === 'rtl' ? 'l' : 'r'} shadow-lg
    py-6 z-30 overflow-hidden
    lg:hidden
    w-72
  `}
      >
        <SidebarLogo />
        <SidebarNav />
      </motion.aside>
    </>
  );
};